export default {
  name: 'rectSpin'
};